/**
 * Sub-nav compartido para todas las rutas bajo /evaluations.
 *
 * - Evaluaciones (default, todos) — assessments
 * - Cuestionarios (todos) — questionnaire_instances
 * - KPIs (admin/lead) — captura de valores
 * - Histórico (todos) — heatmap KPIs
 * - Dashboard (todos) — KPIs en alerta
 */
import { Link } from "@tanstack/react-router";
import type { SessionUser } from "@axorial/shared";

type TabKey = "assessments" | "questionnaires" | "kpis" | "history" | "dashboard";
type Role = SessionUser["role"];

// Tab "assessments" ("Evaluaciones") pausado — ver EVALUATIONS_PAUSED.md.
// La página sigue funcional en /evaluations/assessments sin enlace público.
const ALL_TABS: Array<{ key: TabKey; label: string; to: string; roles?: Role[] }> = [
  { key: "questionnaires", label: "Cuestionarios", to: "/evaluations/questionnaires" },
  {
    key: "kpis",
    label: "KPIs",
    to: "/evaluations/kpis",
    roles: ["admin", "finanzas", "lead"],
  },
  { key: "history", label: "Histórico", to: "/evaluations/history" },
  { key: "dashboard", label: "Dashboard", to: "/evaluations/dashboard" },
];

export function EvaluationsTabs({ current, role }: { current: TabKey; role: Role }) {
  const tabs = ALL_TABS.filter((t) => !t.roles || t.roles.includes(role));
  return (
    <nav className="card-elevated p-1 flex flex-wrap gap-1">
      {tabs.map((t) => (
        <Link
          key={t.key}
          to={t.to}
          className={`btn btn-sm ${current === t.key ? "btn-primary" : "btn-ghost"}`}
        >
          {t.label}
        </Link>
      ))}
    </nav>
  );
}
